import api from './client'

export const smsApi = {
  list: (showArchived = false) =>
    api.get('/api/sms/campaigns', { params: { archived: showArchived } }),

  create: (data) => api.post('/api/sms/campaigns', data),

  update: (id, data) => api.put(`/api/sms/campaigns/${id}`, data),

  archive: (id) => api.post(`/api/sms/campaigns/${id}/archive`),

  unarchive: (id) => api.post(`/api/sms/campaigns/${id}/unarchive`),

  eligible: (id, batchSize = 10) =>
    api.get(`/api/sms/campaigns/${id}/eligible`, { params: { batch_size: batchSize } }),

  send: (id, prospectIds, testPhone = null) =>
    api.post(`/api/sms/campaigns/${id}/send`, {
      prospect_ids: prospectIds,
      test_phone: testPhone,
    }),

  getMessages: (id) => api.get(`/api/sms/campaigns/${id}/messages`),

  getBalance: () => api.get('/api/sms/balance'),
}